<template>
    <rkm-form
        ref="RkmForm"
    >
        <rkm-area
            no-margin-top
            title="DE"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-input-autocomplete
                        v-if="showAutocomplete"
                        :excludeValue="{
                            value: {
                                conectacidadaoCidadaoId: model.cidadaoDestino ? model.cidadaoDestino.conectacidadaoCidadaoId : null,
                                conectasusCidadaoId: model.cidadaoDestino ? model.cidadaoDestino.conectasusCidadaoId : null,
                                pacienteId: model.cidadaoDestino ? model.cidadaoDestino.pacienteId : null,
                                usuarioId: model.cidadaoDestino ? model.cidadaoDestino.usuarioId : null,
                            },
                            prop: ['conectacidadaoCidadaoId', 'conectasusCidadaoId', 'pacienteId', 'usuarioId']
                        }"
                        :repository="repositories.cidadaoAutocomplete"
                        :search-fields="autocompleteFields"
                        :searchFilterFormatter="stringFormatters"
                        :searchTreshold="3"
                        :text-field="item => `${item.nome}`"
                        :validations="{ required: true }"
                        bouncerDelay="700"
                        label="Usuário/paciente de origem"
                        v-model="model.cidadaoOrigem"
                        value-field="conectacidadaoCidadaoId"
                    />
                    <rkm-table
                        :fields="fieldsOrigem"
                        :hideFilters="true"
                        :items="formatData(items.origem)"
                        class="table-newlines"
                        hide-pagination
                    >
                    </rkm-table>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="PARA"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-input-autocomplete
                        v-if="showAutocomplete"
                        :excludeValue="{
                            value: {
                                conectacidadaoCidadaoId: model.cidadaoOrigem ? model.cidadaoOrigem.conectacidadaoCidadaoId : null,
                                conectasusCidadaoId: model.cidadaoOrigem ? model.cidadaoOrigem.conectasusCidadaoId : null,
                                pacienteId: model.cidadaoOrigem ? model.cidadaoOrigem.pacienteId : null,
                                usuarioId: model.cidadaoOrigem ? model.cidadaoOrigem.usuarioId : null,
                            },
                            prop: ['conectacidadaoCidadaoId', 'conectasusCidadaoId', 'pacienteId', 'usuarioId']
                        }"
                        :repository="repositories.cidadaoAutocomplete"
                        :search-fields="autocompleteFields"
                        :searchFilterFormatter="stringFormatters"
                        :searchTreshold="3"
                        :text-field="item => `${item.nome}`"
                        :validations="{ required: true }"
                        bouncerDelay="700"
                        label="Usuário/paciente de destino"
                        v-model="model.cidadaoDestino"
                        value-field="conectacidadaoCidadaoId"
                    />
                    <rkm-table
                        :fields="fieldsDestino"
                        :hideFilters="true"
                        :items="formatData(items.destino)"
                        class="table-newlines"
                        hide-pagination
                    >
                    </rkm-table>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-form>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { error, repository, stringCase } from '@/mixins'

export default {
    computed: {

        fieldsOrigem() {

            let fields = [
                { key: 'tipoCadastro', label: 'Tipo', sortable: false, },
                { key: 'cns', label: 'CNS', sortable: false, },
                { key: 'cpf', label: 'CPF', sortable: false, },
                { key: 'dataNascimento', label: 'Data de nascimento', sortable: false, },
                { key: 'nomeMae', label: 'Nome da mãe', sortable: false, }
            ]

            if (this.model.cidadaoOrigem && (this.model.cidadaoOrigem.tipoCadastro === 'USUÁRIO' ||
                this.model.cidadaoOrigem.tipoCadastro === 'AMBOS')) {
                fields.push({ key: 'usuario', label: 'Usuário', sortable: false });
                fields.push({ key: 'lotacao', label: 'Lotação(es)', sortable: false });
                fields.push({ key: 'ocupacao', label: 'Ocupação(es)', sortable: false });
            }

            return fields
        },
        fieldsDestino() {

            let fields = [
                { key: 'tipoCadastro', label: 'Tipo', sortable: false, },
                { key: 'cns', label: 'CNS', sortable: false, },
                { key: 'cpf', label: 'CPF', sortable: false, },
                { key: 'dataNascimento', label: 'Data de nascimento', sortable: false, },
                { key: 'nomeMae', label: 'Nome da mãe', sortable: false, }
            ]

            if (this.model.cidadaoDestino && (this.model.cidadaoDestino.tipoCadastro === 'USUÁRIO' ||
                this.model.cidadaoDestino.tipoCadastro === 'AMBOS')) {
                fields.push({ key: 'usuario', label: 'Usuário', sortable: false });
                fields.push({ key: 'lotacao', label: 'Lotação(es)', sortable: false });
                fields.push({ key: 'ocupacao', label: 'Ocupação(es)', sortable: false });
            }

            return fields
        },
        autocompleteFields() {

            return [
                { key: 'cadastro_cidadao.cns', searchable: true, },
                { key: 'cadastro_cidadao.cpf', searchable: true, },
                { key: 'cadastro_cidadao.dataNascimento', searchable: true, },
                { key: 'cadastro_cidadao.nome', searchable: true, },
            ]
        },
    },
    created() {

        this.repositories = {
            cidadaoAutocomplete: this.getConectaSusRepository('cadastro.unificaCidadao.cidadao'),
            unificaCidadao: this.getConectaSusRepository('cadastro.unificaCidadao'),
        }
    },
    data: () => ({
        model: {
            cidadaoOrigem: null,
            cidadaoDestino: null,
        },
        items: [],
        showAutocomplete: true,
    }),
    methods: {

        ...mapActions(['setLoading', 'unsetLoading']),
        stringFormatters(e) {

            const birthDate = /^(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/](19|20)\d\d$/;
            if (birthDate.test(e)) {

                const [day, month, year] = e.split('/');
                return `${year}-${month}-${day}`;
            }
            if (e.includes('.' || '-')) {

                return e.replace(/[.-]/g, '');
            }
            return e;

        },
        checkAutocomplete() {

            if (this.model.cidadaoOrigem && this.model.cidadaoDestino) {

                this.$emit('usuarioSelected', true)
            } else {

                this.$emit('usuarioSelected', false)
            }
        },
        confirm() {

            this.createNotification({
                visible: true,
                large: false,
                loading: false,
                title: 'Atenção!',
                message: 'Após unificar os registros, o registro de origem será excluído. Deseja continuar?',
                color: 'danger',
                type: 'dialog',
                confirm: () => {
                    this.unify();
                    return Promise.resolve();
                },
                cancel: () => Promise.resolve(),
                ok: () => Promise.resolve(),
                btnCancel: 'Não',
                btnOk: 'Sim'
            })
        },
        unify() {

            this.setLoading()

            this.repositories.unificaCidadao.update(this.camelObjectKeysToSnakeRecursive(this.model))
                .then(({ data }) => {

                    this.model = {
                        cidadaoOrigem: null,
                        cidadaoDestino: null,
                    }
                    this.showAutocomplete = false
                    this.$nextTick(() => {
                        this.showAutocomplete = true
                    })
                    this.showSaveNotification(data.message)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        formatData(items) {

            if (!items) return [];

            return items.map(item => ({
                ...item,
                lotacao: item.lotacao ? item.lotacao.split(',').join('\n') : '',
                ocupacao: item.ocupacao ? item.ocupacao.split(',').join('\n') : '',
            }));
        },
    },
    mixins: [ error, repository, stringCase ],
    watch: {

        'model.cidadaoOrigem': function(newVal, oldVal) {

            if (this.model && newVal !== oldVal && newVal !== null && newVal !== undefined) {

                this.items.origem = [newVal];
            } else if (this.model && this.model.cidadaoOrigem === null) {

                this.model.cidadaoOrigem = null;
                this.items.origem = [];
            }

            this.checkAutocomplete();
        },
        'model.cidadaoDestino': function(newVal, oldVal) {

            if (this.model && newVal !== oldVal && newVal !== null && newVal !== undefined) {

                this.items.destino = [newVal];
            } else if (this.model && this.model.cidadaoDestino === null) {

                this.model.cidadaoDestino = null;
                this.items.destino = [];
            }

            this.checkAutocomplete();
        },
    }
}
</script>
<style scoped>
    .table-newlines {
        white-space: pre-line;
    }
</style>